import EventBus from 'diagram-js/lib/core/EventBus';
import {EventType} from '@ispm/shared/bpmn-io/bpmn-js';
import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import {OverlayType} from '@ispm/shared/bpmn-io/overlay-types';
import {constants} from '@ispm-client/modules/bpmn-modeler/constants/constants';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {TreeNavigator} from "@ispm/shared/bpmn-io/services/tree-navigator";

export class DeletedIconOverlayBehavior extends CommandInterceptor {

  constructor(protected eventBus: EventBus, private overlays, private treeNavigator: TreeNavigator) {
    super(eventBus);
    eventBus.on([EventType.MARKED_DELETED_CONNECTION, EventType.MARKED_DELETED_NODE], (event) => {

      const element = event.connection ? event.connection : event.node;

      const deletedIconOverlay = this.overlays.get({element: element, type: OverlayType.deleteIconOverlay});
      if (deletedIconOverlay) {
        if (deletedIconOverlay.length !== 0) {
          // We need to remove it and add it again since the line might change due to shapes movement
          this.overlays.remove({element: element, type: OverlayType.deleteIconOverlay});
        }
        this.addDeletedIconOverlay(event);
      }
    });
  }

  addDeletedIconOverlayForConnection(connection) {
    let leftVal, topVal;
    const startPoint = 0;
    const endPoint = connection.waypoints.length - 1;
    const verticalOffset = constants.DELETED_CONNECTION_ICONS_OVERLAYS.top;
    const horizontalOffset = constants.DELETED_CONNECTION_ICONS_OVERLAYS.left;
    const wayPoints = connection.waypoints;
    if (!ModelingUtil.connectionIsStraight(connection)) {
      if (wayPoints.length === 4) /*Z or |_| shaped line*/{
          // The mark is added on the middle part of the connection
          const markedLineStart = 1;
          const markedLineEnd = 2;
          // Marked line is vertical
          if (wayPoints[markedLineStart].x === wayPoints[markedLineEnd].x) {
            topVal =Math.abs(wayPoints[markedLineEnd].y - wayPoints[markedLineStart].y) / 2 + verticalOffset;
            if (wayPoints[markedLineStart].x < wayPoints[startPoint].x && wayPoints[markedLineEnd].x < wayPoints[endPoint].x) {
                leftVal = horizontalOffset;
              } else if (wayPoints[markedLineEnd].x < wayPoints[endPoint].x) {
                leftVal = Math.abs(wayPoints[startPoint].x - wayPoints[markedLineStart].x) + horizontalOffset;
              } else {
                leftVal = wayPoints[markedLineEnd].x - wayPoints[endPoint].x + horizontalOffset;
              }
          // Marked line is horizontal
          } else if (wayPoints[markedLineStart].y === wayPoints[markedLineEnd].y) {
              leftVal = Math.abs(wayPoints[markedLineEnd].x - wayPoints[markedLineStart].x) / 2 + horizontalOffset;
              if (wayPoints[markedLineStart].y < wayPoints[startPoint].y && wayPoints[markedLineEnd].y < wayPoints[endPoint].y) {
                topVal = verticalOffset;
              } else if (wayPoints[markedLineEnd].y < wayPoints[endPoint].y) {
                topVal = Math.abs(wayPoints[startPoint].y - wayPoints[markedLineStart].y) + verticalOffset;
              } else {
                topVal = wayPoints[markedLineEnd].y - wayPoints[endPoint].y + verticalOffset;
              }
          }
      } else if (wayPoints.length === 3) /*L shaped line*/{
        const centerWayPoint = 1;
        if (wayPoints[centerWayPoint].y === wayPoints[startPoint].y){
          topVal = Math.abs(Math.round((wayPoints[centerWayPoint].y - wayPoints[endPoint].y) / 2)) + verticalOffset;
        } else {
          topVal = Math.abs(Math.round((wayPoints[centerWayPoint].y - wayPoints[startPoint].y) / 2)) + verticalOffset;
        }
        if (wayPoints[centerWayPoint].x === wayPoints[endPoint].x && wayPoints[centerWayPoint].x > wayPoints[startPoint].x){
          leftVal = Math.abs(wayPoints[centerWayPoint].x - wayPoints[startPoint].x) + horizontalOffset;
        } else
        if (wayPoints[centerWayPoint].x > wayPoints[endPoint].x) {
          leftVal = wayPoints[centerWayPoint].x - wayPoints[endPoint].x  + horizontalOffset;
        } else {
          leftVal = horizontalOffset;
        }
      }
    } else /*Straight line*/{
      // Marked line is horizontal
      if (wayPoints[endPoint].y === wayPoints[startPoint].y){
        topVal = verticalOffset;
        leftVal = Math.abs(Math.round((wayPoints[startPoint].x  - wayPoints[endPoint].x) / 2)) + horizontalOffset;
      } else /* Marked line is vertical*/{
        leftVal = horizontalOffset;
        topVal = Math.abs(Math.round((wayPoints[startPoint].y  - wayPoints[endPoint].y) / 2)) + verticalOffset;
      }

    }

    this.overlays.add(connection.id, OverlayType.deleteIconOverlay, {
      position: {
        top: topVal,
        left: leftVal
      },
      html: `<i class="deleted-icon-overlay-wrapper icon__Cross"></i>`
    });
  }

  addDeletedIconOverlayForNode(node) {
    if (!node.businessObject.neighborhoodID || this.treeNavigator.currentLayer === node.businessObject.neighborhoodID) {
      this.overlays.add(node.id, OverlayType.deleteIconOverlay, {
        position: {
          top: Math.round((node.height - constants.DELETED_CONNECTION_ICONS_OVERLAYS.height) / 2),
          left: Math.round((node.width - constants.DELETED_CONNECTION_ICONS_OVERLAYS.width) / 2)
        },
        html: `<i class="deleted-icon-overlay-wrapper icon__Cross"></i>`
      });
    }
  }

  private addDeletedIconOverlay(event) {
    const element = event.connection ? event.connection : event.node;

    if (event.connection) {
      this.addDeletedIconOverlayForConnection(element);
    } else {
      this.addDeletedIconOverlayForNode(element);
    }
  }
}


DeletedIconOverlayBehavior.$inject = ['eventBus', 'overlays','treeNavigator'];
